import React from 'react';
import './Home.css';
import { InstagramEmbed } from 'react-social-media-embed';
import { Helmet } from 'react-helmet';
import hibiscusbr from '../images/hibiscusbr.png';
import hibiscustl from '../images/hibiscustl.png';

function Home() {
  const currentCampaignUrl =
    'https://us13.campaign-archive.com/home/?u=155cc7ce50de9517d10acd496&id=a5b122d84a';
  const igUrl = 'https://www.instagram.com/hawaiiclubatuw/';

  return (
    <div className="fade-in">
      {/* Page title for browser tab */}
      <Helmet>
        <title>Home - Hui Hoaloha Ulana</title>
      </Helmet>

      <div className="container">
        {/* Hero Section */}
        <div className="background-image">
          <div className="hero-text content-wrapper">
            <h1 className="title">Hui Hoaloha Ulana</h1>
            <p className="club-description">
              Translated as "a group woven together in friendship," Hui Hoaloha Ulana weaves lifelong
              bonds amongst students brought together by their love or interest in Hawaiʻi.
              We invite everyone from the University of Washington community to participate
              in social and cultural events, sharing our aloha spirit in Seattle.
            </p>
          </div>
        </div>

        <main>
          {/* About Section */}
          <div className="about content-wrapper">
            {/* Decorative Images */}
            <div className="about-decoration">
              <img src={hibiscusbr} alt="decor" className="decor bottom-right" />
              <img src={hibiscustl} alt="decor" className="decor top-left" />
            </div>
            <h2>ALOHA!</h2>
            <p>
              We are Hawai'i Club at the University of Washington! The purpose of Hui Hoaloha Ulana
              is to perpetuate the Hawaiian culture and all other cultures of Hawaii throughout the
              University of Washington and to support students, predominantly those from the
              Hawaiian Islands, in all their collegiate endeavors. We aim to collaborate to create a
              community for our members so they are able to grow as leaders. Feel free to leave us a
              message or browse through our website. Mahalo for stopping by!
            </p>
          </div>

          {/* Embed Section */}
          <div className="embed-title content-wrapper">
            <h2>Stay Connected With Us</h2>
            <p>Check out our Mailchimp newsletter, Instagram, and Slack for all our updates.</p>
          </div>

          {/* Newsletter, Instagram, Slack */}
          <div className="embed-container">
            {/* Newsletter Embed */}
            <div className="newsletter-iframe">
              <iframe
                src={currentCampaignUrl}
                title="Current Newsletter"
                className="newsletter-iframe-inner"
              ></iframe>
            </div>

            {/* Instagram Embed */}
            <div className="instagram-container">
              <InstagramEmbed url={igUrl} width="100%" />
            </div>

            {/* Slack Call to Action */}
            <div className="slack-placeholder">
              <img
                src="https://a.slack-edge.com/80588/marketing/img/icons/icon_slack_hash_colored.png"
                alt="Slack"
                style={{ width: '80px', marginBottom: '1rem' }}
              />
              <p>Join Our Slack!</p>
              <p>Stay connected with Hui Hoaloha Ulana on Slack.</p>
              <a
                href="https://huihoalohaulana.slack.com/join/shared_invite/zt-whuf2ioj-q3rYxaDqbaji2NoDtKZjGg"
                target="_blank"
                rel="noopener noreferrer"
                className="slack-link"
              >
                Join the Channel →
              </a>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}

export default Home;
